import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ReactComponent as Logo } from '../assets/icons/logo.svg'; // Assuming the path is correct

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  const closeMenu = () => {
    setMenuOpen(false);
  };

  return (
    <header className="bg-black text-white fixed w-full z-50 shadow-lg">
      <div className="container mx-auto flex justify-between items-center py-4 px-6">
        <div className="flex items-center">
          <Link to="/" className="text-3xl font-bold" onClick={closeMenu}>
            <Logo className="h-12 w-40" />
          </Link>
        </div>
        <nav className="hidden md:flex space-x-8 items-center">
          <Link to="/" className="text-white hover:text-gray-300 transition duration-300">
            Home
          </Link>
          <Link to="/blog" className="text-white hover:text-gray-300 transition duration-300">
            Blog
          </Link>
          <Link to="/contact" className="text-white hover:text-gray-300 transition duration-300">
            Contact
          </Link>
          <Link
            to="https://dashboard.haulradar.com/sign-up"
            className="ml-4 bg-white text-black py-2 px-4 rounded-full hover:bg-gray-200 transition duration-300"
          >
            Sign Up
          </Link>
        </nav>
        <div className="md:hidden flex items-center">
          <button className="text-white focus:outline-none" onClick={toggleMenu}>
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16m-7 6h7"></path>
            </svg>
          </button>
        </div>
      </div>
      {/* Mobile Menu Tray */}
      <div
        className={`fixed inset-y-0 right-0 w-64 bg-white text-black p-6 z-50 transform transition-transform duration-300 ${
          menuOpen ? 'translate-x-0' : 'translate-x-full'
        }`}
        onClick={(e) => e.stopPropagation()} // Prevent click from closing the menu when clicking inside the tray
      >
        <nav className="flex flex-col space-y-6">
          <Link to="/" className="text-black hover:text-gray-600 transition duration-300" onClick={closeMenu}>
            Home
          </Link>
          <Link to="/blog" className="text-black hover:text-gray-600 transition duration-300" onClick={closeMenu}>
            Blog
          </Link>
          <Link to="/contact" className="text-black hover:text-gray-600 transition duration-300" onClick={closeMenu}>
            Contact
          </Link>
          <Link
            to="https://dashboard.haulradar.com/sign-up"
            className="bg-black text-white py-2 px-4 rounded-full hover:bg-gray-800 transition duration-300"
            onClick={closeMenu}
          >
            Sign Up
          </Link>
        </nav>
      </div>
      {menuOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 z-40"
          onClick={closeMenu}
        ></div>
      )}
    </header>
  );
};

export default Header;
